import React from 'react';
import _ from 'lodash';
import styles from './css/Button.styl';

/**
 * Button module
 */
export default class Button extends React.Component {
  static propTypes = {
    ariaExpanded: React.PropTypes.string,
    ariaHaspopup: React.PropTypes.string,
    ariaHidden: React.PropTypes.string,
    ariaLabel: React.PropTypes.string,
    ariaPressed: React.PropTypes.string,
    btnType: React.PropTypes.oneOf(['default', 'primary', 'secondary', 'none']),
    children: React.PropTypes.node,
    className: React.PropTypes.string,
    disabled: React.PropTypes.bool,
    handleClick: React.PropTypes.func,
    id: React.PropTypes.string,
    type: React.PropTypes.oneOf(['button', 'reset', 'submit']),
  };

  static defaultProps = {
    btnType: 'default',
    type: 'button',
  };

  /**
   * Button Component Constructor
   * @param  {Object} props Passed in Properties
   * @return {Undefined} Returns nothing
   */
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  /**
   * Constructs the class string for the button
   * @param  {String}  btnType    The type of button
   * @param  {Boolean} isDisabled If the button is disabled
   * @param  {String}  className  The appended classes
   * @return {String} The constructed class string
   */
  getClasses(btnType, isDisabled, className) {
    const disabled = isDisabled ? ` ${styles.disabled}` : '';
    const appended = className ? ` ${className}` : '';
    const btnTypeClass = styles[btnType] ? ` ${styles[btnType]}` : '';

    return `${styles.button}${btnTypeClass}${disabled}${appended}`;
  }

  /**
   * Formats the id if one is present in props
   * @param  {String} id The id string
   * @return {String} The constructed id
   */
  getId(id) {
    return id ? `${id}_button` : null;
  }

  /**
   * Handler for when the button is clicked
   * @param  {Object} e The Event object
   * @return {Undefined} Returns nothing
   */
  handleClick(e) {
    if (this.props.disabled) {
      e.preventDefault();
    } else if (_.isFunction(this.props.handleClick)) {
      this.props.handleClick(e);
    }
  }

  /**
   * React Component render
   * @return {JSX} Button rendered
   */
  render() {
    return (
      <button
        aria-expanded={this.props.ariaExpanded}
        aria-haspopup={this.props.ariaHaspopup}
        aria-hidden={this.props.ariaHidden}
        aria-label={this.props.ariaLabel}
        aria-pressed={this.props.ariaPressed}
        className={this.getClasses(
          this.props.btnType,
          this.props.disabled,
          this.props.className
        )}
        disabled={this.props.disabled}
        id={this.getId(this.props.id)}
        onClick={this.handleClick}
        type={this.props.type}
      >
        {this.props.children}
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/reactModules/shared/library/FormControls/Button.js